import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingModal = () => (
  <div
    className="fixed z-[10] inset-0 flex items-center justify-center bg-black bg-opacity-70"
    aria-label="loading"
  >
    <CircularProgress color="primary" aria-label="loading" role="status" />
  </div>
);

export default LoadingModal;
